import classnames from 'classnames';
import moment from 'moment';

type ActiveIntegrationsTimeRangeFiltersProps = {
  queryStartDate: moment.Moment;
  setQueryStartDate: (arg: moment.Moment) => void;
};
function ActiveIntegrationsTimeRangeFilters({
  queryStartDate,
  setQueryStartDate,
}: ActiveIntegrationsTimeRangeFiltersProps) {
  const timeRanges = [
    { label: 'Last 7 Days', startDate: dateRangeStartDate(-7, 'day') },
    { label: 'Last 14 Days', startDate: dateRangeStartDate(-14, 'day') },
    { label: 'Last 30 Days', startDate: dateRangeStartDate(-30, 'day') },
    { label: 'Last 3 Months', startDate: dateRangeStartDate(-3, 'month') },
    { label: 'Last Year', startDate: dateRangeStartDate(-1, 'year') },
    { label: 'All Time', startDate: dateRangeStartDate(-2, 'year') },
  ];

  return (
    <div className="flex py-2 text-base font-medium text-gray-600 min-h-[2.5rem] gap-x-4">
      <div>Show data for:</div>
      <div className={classnames('flex gap-4', {})}>
        {timeRanges.map((x) => {
          return (
            <div
              className={classnames('flex', {
                'border-l border-gray-200 pl-4': x.label == 'All Time',
              })}
              key={x.label}
            >
              <button
                className={classnames('rounded px-2', {
                  'bg-blue-400 text-white': moment(x.startDate).isSame(
                    queryStartDate,
                    'day',
                  ),
                })}
                onClick={() => setQueryStartDate(x.startDate)}
              >
                {x.label}
              </button>
            </div>
          );
        })}
      </div>
    </div>
  );
}
function dateRangeStartDate(
  amountToAdd: number,
  unit: moment.DurationInputArg2,
) {
  return moment().add(amountToAdd, unit);
}

export default ActiveIntegrationsTimeRangeFilters;
